const permissions = {
  createLanguage: 'create language',
  writeLanguage: 'write language',
  readLanguage: 'read language',
  deleteLanguage: 'delete language',
  readEmailTemplate: 'read email template',
  writeEmailTemplate: 'write email template',
  readHelpContents: 'read help contents',
  writeHelpContents: 'write help contents',
  readAllPermissions: 'read all permissions',
  readPermission: 'read permission',
  readAllRoles: 'read all roles',
  readRole: 'read role',
  writeRole: 'write role',
  deleteRole: 'delete role',
  assignPermissions: 'assign permissions',
  readAllScopes: 'read all scopes',
  readScope: 'read scope',
  writeScope: 'write scope',
  createScope: 'create scope',
  deleteScope: 'delete scope',
  readAllActivities: 'read all activities',
  writeTranslation: 'write translation',
  readAllUsers: 'read all users',
  updateUser: 'update user',
  impersonateUser: 'impersonate user',
  addUser: 'create user',
  readScopeNavCredentials: 'read scope nav credentials',
  writeScopeNavCredentials: 'write scope nav credentials',
  readScopeMailCredentials: 'read scope mail credentials',
  writeScopeMailCredentials: 'write scope mail credentials',
  readScopeEmails: 'read scope emails',
  writeScopeEmails: 'write scope emails',
  readTimesheetSummary: 'read timesheet summary',
  readTimesheetForm: 'read timesheet form',
  submitTimesheetForm: 'submit timesheet form',
  approveTimesheetForm: 'approve timesheet form',
  approveTimesheetSummary: 'approve timesheet summary',
  updateTimesheetForm: 'update timesheet form',
  readPrivacyAndTerms: 'read privacy and terms',
  writePrivacyAndTerms: 'write privacy and terms',
  writeSmsTemplate: 'write sms template',
  readSmsTemplate: 'read sms template',
  readSmsHistory: 'read sms history',
  readScopeSmsCredentials: 'read scope sms credentials',
  writeScopeSmsCredentials: 'write scope sms credentials',
  readSmsSettings: 'read sms settings',
  writeSmsSettings: 'write sms setting',
  writeTimesheetConfig: 'write timesheet config',
  writeCronConfig: 'write cron config',
  exportUsers: 'export users',
  readInvoice: 'read invoice',
  createInvoice: 'create invoice',
  readAllInvoices: 'read all invoices',
  addInvoice: 'add invoice',
  updateInvoice: 'update invoice',
  deleteInvoice: 'delete invoice',
  exportInvoices: 'export invoices'
}

export default permissions;
